import React, { useEffect, useCallback, useState} from 'react';
import MessageInlets from "components/messaging/MessageInlets.js";
import MessageOutlets from "components/messaging/MessageOutlets.js";
import OutputNode from "components/pulled/OutputNode.js";
import PadComponent from "components/pads/PadComponent.js";
import {connect} from 'react-redux';

const ZPad = ({scrollContainer, pad, zobject, padWrapper, styling, width, height}) => { 
    if (!pad) {
        return '';
    }
    return (<div className="z-pad">
              <PadComponent
                zobject={zobject}
                width={width-10}
                height={height}
                attributes={zobject.attributes}
                scrollContainer={scrollContainer}
                isPulled={true}
                pad={pad}/>
              <MessageInlets subSequence={zobject.subSequence} effect={pad}/>
              <MessageOutlets subSequence={zobject.subSequence} containerRef={scrollContainer} effect={pad}/>
              <OutputNode
                isRoot={true}
                useClick={true} hideNumber={true} sequencerEngine={pad.sequencerEngine} node={pad}/>
            </div>);
}

const mapStateToProps = (state, props) => {
  return {
      pad: props.padWrapper.pad,
      styling: state.zobject.objectStylings[props.zobject.id],
      width: props.zobject.width,
      height: props.zobject.height
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZPad);
